<template>
    <v-container >

        <div>
            <v-breadcrumbs :items="breadcrumbs" v-if="$local_storage.get('tipo_usuario') == 'Super Usuario' || $local_storage.get('id_cliente') > 0" >
                <v-icon slot="divider" >forward</v-icon>
            </v-breadcrumbs>
        </div>
       <v-row>

      <v-col
        cols="12"
      >
        <base-material-card
          color="primary"
          icon="library_books"
          title="Grupos Disponibles"
          class="px-5 py-3"
        >
         <v-card-text class="pa-0"  >

              <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()" >


                            <v-client-table ref="vuetable" id="lista_clientes" :data="clientes.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="select" slot-scope="props" >
                                    <v-btn fab x-small color="primary" @click="carga_datos(props.row)" >
                                        <v-icon>input</v-icon>
                                    </v-btn>
                                </template>
                            </v-client-table>

                        </div>

                    </v-card-text>



      <!--     <v-card-actions>
            <v-btn
              color="success"
              min-width="100"
              class="pl-0"
            >
              Sign In
            </v-btn>
          </v-card-actions> -->
        </base-material-card>
      </v-col>

    </v-row>

    </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import PaginacionComponent from '@/components/PaginacionComponent.vue';

export default {
    created: function(){

         if (this.$local_storage.get("tipo_usuario") == "Super Usuario") {
                this.$local_storage.set("soloCartaPorte", 0);
                this.$local_storage.set("carta_porte", 0);
                this.$store.state.carta_porte = 0;
                this.$local_storage.set("id_cliente", 0);
                this.$local_storage.set("cambio_cliente", true);
                this.$local_storage.set("rfc", "");
                this.$local_storage.set("razon", "");
                this.$local_storage.set("panel_grupo", 0);
                this.$local_storage.set("es_transportista", 0);
                this.$local_storage.set("es_agente", 0);
                this.$local_storage.set("rfc_grupo", "");
                this.$local_storage.set("rfc_agencia", "");
                this.$local_storage.set("nombre_grupo", "");
                this.$local_storage.set("id_grupo", 0);
                this.$local_storage.set("id_perfil" , 0);
                this.$local_storage.set("perfil_grupo", 0);
                this.$local_storage.set("rfc_agencia", "");
                this.$local_storage.set("es_agencia", "0");
                this.$user.set({
                    id_cliente: 0
                });
                this.$store.state.id_cliente = -1;
        }
        if (this.$local_storage.get("tipo_usuario") == "Cliente") {
            delete this.options.headings["fecha_ingreso"];
            delete this.options.headings["fecha_vencimiento"];
            var keyFI = 0;
            var keyFV = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "fecha_ingreso") keyFI = k;
                if (this.columns[k] == "fecha_vencimiento") keyFV = k;
            }
            if (keyFI > 0) delete this.columns[keyFI];
            if (keyFV > 0) delete this.columns[keyFV];
        }
        this.mostrarmenu();
    },
    mounted: function() {
        this.carga_clientes();
    },

    computed: {
        computeLogo() {
            return "/static/logo_blanco.png";
        }
    },

    methods: {
        carga_clientes: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var url = this.$hostname + "grupos/";

            var self = this;
            axios
                .get(url)
                .then(function(response) {
                   // self.clientes.items = response.data.filter(t => t.es_transportista === 1 || t.es_agente === 1 );
                    self.clientes.items = response.data;
                      for (var k in self.clientes.items) {
                            if(self.clientes.items[k].es_transportista==1)
                            self.clientes.items[k].tipo="TRANSPORTISTA";
                             else if(self.clientes.items[k].es_agente==1)
                             self.clientes.items[k].tipo="AGENTE ADUANAL";
                            else if(self.clientes.items[k].es_agente==2)
                             self.clientes.items[k].tipo="DESPACHO DE ADUANA";
                            else if(self.clientes.items[k].panel==1)
                            self.clientes.items[k].tipo="SUPER PANEL";
                            else
                            self.clientes.items[k].tipo="NORMAL";

                        }
                     self.clientes.items  =  self.clientes.items.sort(function (a, b) {
                        return a.nombre > b.nombre;
                    });
                    self.$root.$dialogLoader.hide();
                })
                .catch(function(error) {

                    console.log(error);
                    self.$root.$dialogLoader.hide();
                    self.$router.push("/").catch(()=>{});

                });
        },
        inicializapermisos: async function(estatus) {
            var result = [];
            var data = {
                sistema: this.$sistema,
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            };

            var url = this.$hostname + "sistemas/get_permisos_sistema/";
            let self = this;
            await axios
                .post(url, data)
                .then(function(response) {
                    response.data.forEach(function(element) {
                        self.$local_storage.set(element.clave, estatus);

                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
            return result;
        },
        regresar() {
            if (this.$local_storage.get("id_cliente") > 0) {
                this.$router.push("/home").catch(()=>{});
            } else {
                if (this.$local_storage.get("tipo_usuario") == "Super Usuario") {
                    this.$router.push("/admin").catch(()=>{});
                } else {
                    this.$router.push("/").catch(()=>{});
                }
            }
        },
        mostrarmenu: function (val) {
            //Se actualiza la variable store.state.datetime para forzar a recargar el componente de AppBar.vue
            //Esta variable se manda llamar en el archivo App.vue
            this.$store.state.datetime = moment(new Date()).format("x"); //Unix timestamp
        },

        carga_datos: async function (reg) {

           await this.inicializapermisos(0);
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.$local_storage.set("subtipo_usuario", "");
            this.$local_storage.set("referencia_usuario", "");
            this.$local_storage.set("consignatario_usuario", "");
            this.$local_storage.set("trafico", 0);
            this.$local_storage.set("costing", 0);
            this.$local_storage.set('emanifiesto', 0);
            this.$local_storage.set('carta_porte', 0);

            this.$local_storage.set("panel_grupo", reg.panel);
            this.$local_storage.set("es_transportista", reg.es_transportista);
            this.$local_storage.set("es_agente", reg.es_agente);
            this.$local_storage.set("rfc_grupo", reg.rfc);
            this.$local_storage.set("nombre_grupo", reg.nombre);
            this.$local_storage.set("id_grupo", reg.id_grupo);
            this.$local_storage.set("id_cliente", 0);
            this.$local_storage.set("cambio_cliente", true);
            this.$local_storage.set("rfc", "");
            this.$local_storage.set("razon", "");
            this.$local_storage.set("rfc_agencia", "");
            this.$local_storage.set("es_agencia", "0");
            if(reg.es_agente == 2)
                {
                  this.$local_storage.set("rfc_agencia", reg.rfc);
                  this.$local_storage.set("es_agencia", "1");
                }

            this.mostrarmenu(true);

            if(reg.es_transportista == 1)
                this.$router.replace("/indext").catch(()=>{});
            else if(reg.es_agente == 1)
                this.$router.replace("/indexAA").catch(()=>{});
            else if(reg.es_agente == 2)
                this.$router.replace("/indexDA").catch(()=>{});
            else if(reg.panel == 1)
                this.$router.replace("/admin").catch(()=>{});
            else
                this.$router.replace("/listaclientes").catch(()=>{});

        }
    },

    data() {
        return {
            model_filters: '',
            pwPagination: {
                total: 0,
                links: {
                    url: this.$hostname + "usuarios/get_clientes_usuario/",
                    next: '',
                    prev: '',
                },
                options: {
                    tipo: 1,
                    size: 10,
                    loading: this.showLoading,
                    filters: {}
                }
            },
            name: "datagrid",
             columns: [
                 "select",
                "nombre",
                "rfc",
                "razon_social",
                "tipo",

            ],
            show_loading: true,
            options: {
                filterable: ["nombre", "razon_social", "rfc", "tipo"],
                sortable: ["nombre", "razon_social", "rfc", "tipo"],
                 listColumns: {
                    tipo: [{
                            id: "NORMAL",
                            text: "NORMAL"
                        },
                        {
                            id: "TRANSPORTISTA",
                            text: "TRANSPORTISTA"
                        },
                        {
                            id: "AGENCIA ADUANAL",
                            text: "AGENCIA ADUANAL"
                        },
                         {
                            id: "DESPACHO DE ADUANA",
                            text: "DESPACHO DE ADUANA"
                        },
                        {
                            id: "SUPER PANEL",
                            text: "SUPER PANEL"
                        }
                    ],
         },
                headings: {
                    select:  "",
                    nombre: "Nombre",
                    razon_social: "Razón Social",
                    rfc: "RFC o TAX ID",
                    tipo: "Tipo"

                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Lista de Grupos",
                    disabled: true,
                    href: ""
                }
            ],
            search: "",
            show_loading: true,
            lista_clientes: [],
            clientes: {
                selected: [],
                headers: [{
                        text: "",
                        value: "icon"
                    },
                    {
                        text: "RFC ",
                        value: "rfc"
                    },
                    {
                        text: "RAZÓN SOCIAL ",
                        value: "razon"
                    }
                ],
                items: [0]
            }
        };
    }
};
</script>
<style>
#lista_clientes tr td:nth-child(1) {
    width: 60px;
}

#lista_clientes tr td:nth-child(2) {
    width: 200px;
}
</style>
